import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BalanceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"balance"}/>
}
